import FormatDlItem from '@/assets/formats/format-dl-item'
const formatsIndex = [
    new FormatDlItem({
        id: 'dl_1',
        title: '기본 이력서양식',
        type: 'hwp',
        description: '',
        dl: '/static/dl/001.hwp',
        thumbnail: '/kr/resume/static/img/dl/001.png',
    }),

    new FormatDlItem({
        id: 'dl_2',
        title: '기본 이력서&자기소개서',
        type: 'hwp',
        description: '',
        dl: '/static/dl/002.hwp',
        thumbnail: '/kr/resume/static/img/dl/002.png',
    }),
    new FormatDlItem({
        id: 'dl_3',
        title: '기본 상세 이력서',
        type: 'hwp',
        description: '',
        dl: '/static/dl/003.hwp',
        thumbnail: '/kr/resume/static/img/dl/003.png',
    }),

]


export default formatsIndex
